import { TransformMode } from "./TransformMode.js";

class TransformModeRectangleClass implements TransformMode {
    public extract(element: HTMLElement): DOMMatrix {
        const globalBounds = element.getBoundingClientRect();
        const matrix = new DOMMatrix();

        let x = globalBounds.x;
        let y = globalBounds.y;
        // x += parseFloat(window.getComputedStyle(element).paddingLeft);
        // y += parseFloat(window.getComputedStyle(element).paddingTop);
        // x += parseFloat(window.getComputedStyle(element).borderLeftWidth);
        // y += parseFloat(window.getComputedStyle(element).borderTopWidth);
        matrix.translateSelf(x, y, 0);

        const style = window.getComputedStyle(element);

        let ew = parseFloat(style.width);
        let eh = parseFloat(style.height);

        var scX = NaN;
        if (globalBounds.width !== ew && ew !== 0) {
            scX = globalBounds.width / ew;
        }

        var scY = NaN;
        if (globalBounds.height !== eh && eh !== 0) {
            scY = globalBounds.height / eh;
        }

        if (isNaN(scX) && isNaN(scY)) {
            scX = 1;
            scY = 1;
        } else if (isNaN(scX)) {
            scX = scY;
        } else if (isNaN(scY)) {
            scY = scX;
        }

        if (scX !== 1 || scY !== 1) {
            matrix.scaleSelf(scX, scY, 1);
        }

        return matrix;
    }

    // public extract(transform: Transform, matrix: Matrix3d): void {
    //     var globalBounds = Rect.getBounds(transform.element);
    //     matrix.prependPosition(globalBounds.x, globalBounds.y, 0);
    //     var scX = 1;
    //     if (globalBounds.width !== transform.element.offsetWidth
    //         && transform.element.offsetWidth !== 0) {
    //         scX = globalBounds.width / transform.element.offsetWidth;
    //     }
    //     var scY = 1;
    //     if (globalBounds.height !== transform.element.offsetHeight
    //         && transform.element.offsetHeight !== 0) {
    //         scY = globalBounds.height / transform.element.offsetHeight;
    //     }
    //     if (scX !== 1 || scY !== 1) {
    //         matrix.appendScale(scX, scY, 1);
    //     }
    // }
}

export const TransformModeRectangle = new TransformModeRectangleClass();
